webpackJsonp([131683993344931],{

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _colorManipulator = __webpack_require__(55);
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 5
	    },
	    colorPrimary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
	    },
	    colorSecondary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
	    },
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	    query: {
	      transform: 'rotate(180deg)'
	    },
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: 'buffer 3s infinite linear'
	    },
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    bar1Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	    bar2Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
	      animationDelay: '1.15s'
	    },
	    bar1Determinate: {
	      willChange: 'transform',
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes mui-indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes mui-indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function LinearProgress(props) {
	  var _classNames, _classNames2, _classNames3, _classNames4;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
	  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
	  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
	  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className,
	    role: "progressbar"
	  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
	    className: dashedClass
	  }) : null, _react.default.createElement("div", {
	    className: bar1ClassName,
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : _react.default.createElement("div", {
	    className: bar2ClassName,
	    style: inlineStyles.bar2
	  }));
	}
	
	LinearProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant of progress indicator. Use indeterminate or query
	   * when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
	} : {};
	LinearProgress.defaultProps = {
	  color: 'primary',
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(158));

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoAndroidCheckmarkCircle = function IoAndroidCheckmarkCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 16.9l5 5 14-13.9 2.3 2.2-16.3 16.3-7.3-7.3z m19.6 3.1h3.3c0 8.9-7.3 16.3-16.2 16.3s-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2c2.1 0 4.2 0.4 6 1.2l-2.5 2.5c-1.1-0.3-2.3-0.5-3.5-0.5-7.2 0-13 5.8-13 13s5.8 13 13 13 12.9-5.8 12.9-13z' })
	        )
	    );
	};
	
	exports.default = IoAndroidCheckmarkCircle;
	module.exports = exports['default'];

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdErrorOutline = function MdErrorOutline(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 33.4c7.3 0 13.4-6.1 13.4-13.4s-6.1-13.4-13.4-13.4-13.4 6.1-13.4 13.4 6.1 13.4 13.4 13.4z m0-30c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z m-1.6 8.2h3.2v10h-3.2v-10z m0 13.4h3.2v3.4h-3.2v-3.4z' })
	        )
	    );
	};
	
	exports.default = MdErrorOutline;
	module.exports = exports['default'];

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _SmartQuotes = __webpack_require__(939);
	
	var _SmartQuotes2 = _interopRequireDefault(_SmartQuotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _quote;
	
	  return {
	    root: {
	      margin: '10px auto',
	      padding: '25px 15px',
	      background: '#f4f8fb',
	      border: '1px solid #d1bade',
	      // border: `1px solid ${theme.palette.borders.cloudiest}`,
	      color: theme.palette.quote,
	      fontWeight: 500
	    },
	    header: {
	      textTransform: 'uppercase',
	      color: '#a974ba',
	      fontWeight: 500,
	      fontSize: '0.75em',
	      marginBottom: 2
	    },
	    quote: (_quote = {
	      fontWeight: 700,
	      color: '#6c9bab',
	      fontStyle: 'italic',
	      textTransform: 'none',
	      fontSize: '1.4em'
	    }, _quote[theme.breakpoints.down('xs')] = {
	      fontSize: '1em',
	      fontWeight: 700
	    }, _quote)
	  };
	};
	
	var Quote = function Quote(props) {
	  var classes = props.classes,
	      author = props.author,
	      quote = props.quote,
	      tags = props.tags;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(
	      _Typography2.default,
	      { align: 'center', className: classes.header },
	      'Inspiration of the article:'
	    ),
	    _react2.default.createElement(
	      _Typography2.default,
	      { align: 'center', variant: 'title', className: classes.quote },
	      _react2.default.createElement(_SmartQuotes2.default, { quote: quote }),
	      ' ',
	      author && '\u2014' + author
	    )
	  );
	};
	
	Quote.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  author: _propTypes2.default.string,
	  quote: _propTypes2.default.string.isRequired,
	  tags: _propTypes2.default.array.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Quote);
	module.exports = exports['default'];

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reactShare = __webpack_require__(826);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _root, _shareButton, _shareIcon;
	
	  return {
	    root: (_root = {
	      width: '100%',
	      maxWidth: 50,
	      position: 'fixed',
	      zIndex: 1,
	      top: '30vh',
	      left: 50,
	      overflow: 'hidden'
	    }, _root[theme.breakpoints.down('sm')] = {
	      left: 6
	    }, _root[theme.breakpoints.down('xs')] = {
	      top: '35%',
	      left: 2,
	      width: 20,
	      maxWidth: 20
	    }, _root),
	    shareButton: (_shareButton = {}, _shareButton[theme.breakpoints.down('xs')] = {
	      width: 20,
	      height: 20
	    }, _shareButton),
	    shareIcon: (_shareIcon = {
	      '&:hover': {
	        opacity: 0.7
	      }
	    }, _shareIcon[theme.breakpoints.down('xs')] = {
	      width: 20,
	      height: 20
	    }, _shareIcon)
	  };
	};
	
	var Shares = function Shares(props) {
	  var classes = props.classes,
	      data = props.data,
	      url = props.url;
	
	
	  return data.map(function (shareProps, i) {
	    var shareButton = shareProps.shareButton,
	        icon = shareProps.icon,
	        otherProps = _objectWithoutProperties(shareProps, ['shareButton', 'icon']);
	
	    var ShareButton = shareButton;
	    var Icon = icon;
	
	    var size = 45;
	
	    return _react2.default.createElement(
	      'div',
	      { key: 'ficon' + i, style: { marginBottom: 8 } },
	      _react2.default.createElement(
	        ShareButton,
	        _extends({
	          style: { cursor: 'pointer', width: size },
	          url: url,
	          className: classes.shareButton
	        }, otherProps),
	        _react2.default.createElement(Icon, { className: classes.shareIcon, size: size })
	      )
	    );
	  });
	};
	
	Shares.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	
	var FloatingSidebar = function FloatingSidebar(props) {
	  var classes = props.classes,
	      shareLink = props.shareLink,
	      title = props.title,
	      thumbnail = props.thumbnail,
	      otherProps = _objectWithoutProperties(props, ['classes', 'shareLink', 'title', 'thumbnail']);
	
	  var data = [{
	    shareButton: _reactShare.PinterestShareButton,
	    icon: _reactShare.PinterestIcon,
	    description: title,
	    media: thumbnail,
	    countIcon: _reactShare.PinterestShareCount
	  }, {
	    shareButton: _reactShare.TwitterShareButton,
	    icon: _reactShare.TwitterIcon,
	    title: title,
	    via: 'healthfulinspir'
	  }, {
	    shareButton: _reactShare.FacebookShareButton,
	    icon: _reactShare.FacebookIcon,
	    quote: title,
	    via: 'healthfulinspir'
	  }, {
	    shareButton: _reactShare.GooglePlusShareButton,
	    icon: _reactShare.GooglePlusIcon
	  }, {
	    shareButton: _reactShare.TumblrShareButton,
	    icon: _reactShare.TumblrIcon
	  }, {
	    shareButton: _reactShare.RedditShareButton,
	    icon: _reactShare.RedditIcon,
	    title: title
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: classes.root }, otherProps),
	    _react2.default.createElement(Shares, { classes: classes, data: data, url: shareLink })
	  );
	};
	
	FloatingSidebar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  shareLink: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  thumbnail: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(FloatingSidebar);
	module.exports = exports['default'];

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(127);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Input = __webpack_require__(67);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _onlyUpdateForKeys = __webpack_require__(844);
	
	var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  return {
	    field: {
	      margin: theme.spacing.unit
	    }
	  };
	};
	
	var renderInputField = function renderInputField(_ref) {
	  var input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      customProps = _objectWithoutProperties(_ref, ['input', 'meta']);
	
	  return (
	    // TODO: add error msg
	    _react2.default.createElement(
	      'div',
	      null,
	      error && error,
	      _react2.default.createElement(_Input2.default, _extends({ error: touched && !!error }, input, customProps))
	    )
	  );
	};
	
	var ReduxFormInput = function ReduxFormInput(props) {
	  var _cx;
	
	  var classes = props.classes,
	      className = props.className,
	      id = props.id,
	      autoFill = props.autoFill,
	      inputRef = props.inputRef,
	      name = props.name,
	      fullWidth = props.fullWidth,
	      required = props.required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      multiline = props.multiline,
	      restProps = _objectWithoutProperties(props, ['classes', 'className', 'id', 'autoFill', 'inputRef', 'name', 'fullWidth', 'required', 'rows', 'rowsMax', 'multiline']);
	
	  return _react2.default.createElement(_reduxForm.Field, _extends({
	    id: id,
	    autoComplete: 'section-red shipping ' + autoFill,
	    inputProps: {
	      className: (0, _classnames2.default)((_cx = {}, _cx[className] = !!className, _cx), classes.field)
	    },
	    inputRef: inputRef,
	    name: name,
	    component: renderInputField,
	    fullWidth: fullWidth && true,
	    required: !!required,
	    rows: rows || 8,
	    rowsMax: rowsMax || 10,
	    multiline: !!multiline
	  }, restProps));
	};
	
	exports.default = (0, _compose2.default)((0, _onlyUpdateForKeys2.default)(['className']), (0, _withStyles2.default)(styles)(ReduxFormInput));
	module.exports = exports['default'];

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _smartQuote;
	
	  return {
	    smartQuote: (_smartQuote = {
	      fontFamily: 'Arial',
	      fontSize: '1.6em',
	      position: 'relative',
	      top: 7,
	      padding: 3
	    }, _smartQuote[theme.breakpoints.down('xs')] = {
	      top: 2,
	      padding: 1,
	      fontSize: '1.4em'
	    }, _smartQuote)
	  };
	};
	
	var SmartQuotes = function SmartQuotes(props) {
	  var classes = props.classes,
	      quote = props.quote;
	
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'span',
	      { className: classes.smartQuote },
	      '\u201C'
	    ),
	    quote,
	    _react2.default.createElement(
	      'span',
	      { className: classes.smartQuote },
	      '\u201D'
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(styles)(SmartQuotes);
	module.exports = exports['default'];

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(127);
	
	var _ReduxFormInput = __webpack_require__(935);
	
	var _ReduxFormInput2 = _interopRequireDefault(_ReduxFormInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetlifyForm = function NetlifyForm(props) {
	  var render = props.render,
	      method = props.method,
	      formName = props.formName,
	      onSubmit = props.onSubmit,
	      className = props.className,
	      style = props.style;
	
	
	  if (!formName) {
	    throw new Error('You need to provide a name for the form');
	  }
	  if (typeof onSubmit !== 'function') {
	    throw new Error('Please provide an onSubmit handler');
	  }
	  if (typeof render !== 'function') {
	    throw new Error('You need to implement the render() prop as a function');
	  }
	
	  var Form = function Form(props) {
	    var children = props.children,
	        handleSubmit = props.handleSubmit,
	        submitting = props.submitting;
	
	    return _react2.default.createElement(
	      'form',
	      {
	        onSubmit: handleSubmit(onSubmit),
	        method: method || 'post',
	        name: formName,
	        className: className,
	        style: _extends({ opacity: submitting ? 0.4 : 1 }, style),
	        'data-netlify': 'true',
	        'data-netlify-honeypot': 'bot-field'
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: formName }),
	      children
	    );
	  };
	
	  var FormWithReduxForm = (0, _reduxForm.reduxForm)({
	    method: method || 'post',
	    formName: formName,
	    onSubmit: onSubmit
	  })(Form);
	
	  return render({
	    Form: FormWithReduxForm,
	    Input: _ReduxFormInput2.default,
	    TextArea: function TextArea(props) {
	      return _react2.default.createElement(_ReduxFormInput2.default, _extends({}, props, { multiline: true }));
	    }
	  });
	};
	
	NetlifyForm.propTypes = {
	  render: _propTypes2.default.func.isRequired,
	  method: _propTypes2.default.string,
	  formName: _propTypes2.default.string.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	exports.default = NetlifyForm;
	module.exports = exports['default'];

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(64);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _FormHelperText = __webpack_require__(241);
	
	var _FormHelperText2 = _interopRequireDefault(_FormHelperText);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reduxForm = __webpack_require__(127);
	
	var _Input = __webpack_require__(67);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _LinearProgress = __webpack_require__(159);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _androidCheckmarkCircle = __webpack_require__(208);
	
	var _androidCheckmarkCircle2 = _interopRequireDefault(_androidCheckmarkCircle);
	
	var _errorOutline = __webpack_require__(730);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _app = __webpack_require__(131);
	
	var _regexp = __webpack_require__(290);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _button, _form, _header, _inputs, _emailInput, _subscribeButton, _successText, _errorText;
	
	  return {
	    form: (_form = {
	      position: 'relative',
	      width: '100%',
	      backgroundColor: 'rgba(34, 34, 34, 0.95)',
	      padding: 18
	    }, _form[theme.breakpoints.down('xs')] = {
	      padding: 13,
	      width: '100%',
	      fontSize: '0.95em'
	    }, _form['& > button'] = (_button = {}, _button[theme.breakpoints.down('xs')] = {
	      fontSize: '0.65em',
	      color: 'red'
	    }, _button), _form),
	    bg: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      right: 0,
	      content: '',
	      opacity: 1,
	      zIndex: -1,
	      background: 'url(https://s3-us-west-1.amazonaws.com/healthfulinspired/app/woman-800x533.jpg)',
	      backgroundPosition: 'top 10% left 50%'
	    },
	    header: (_header = {
	      padding: 8,
	      fontWeight: 400,
	      color: '#fff'
	    }, _header[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _header),
	    inputs: (_inputs = {
	      marginBottom: 5,
	      width: '50%',
	      textAlign: 'center'
	    }, _inputs[theme.breakpoints.down('xs')] = {
	      padding: 7,
	      marginBottom: 3
	    }, _inputs),
	    helperText: {
	      fontSize: '0.9em',
	      marginBottom: 5,
	      textAlign: 'center',
	      color: '#fff',
	      fontWeight: 300
	    },
	    emailInput: (_emailInput = {
	      float: 'left',
	      fontFamily: 'Roboto',
	      height: '100%',
	      maxHeight: 36,
	      fontWeight: 400,
	      width: '50%',
	      background: theme.palette.background.light,
	      color: theme.palette.primary.main,
	      border: '1px solid ' + theme.palette.borders.cloudier,
	      '&::placeholder': {
	        fontFamily: 'Roboto'
	      }
	    }, _emailInput[theme.breakpoints.down('xs')] = {
	      fontSize: '1em',
	      maxHeight: 33
	    }, _emailInput),
	    subscribeButton: (_subscribeButton = {
	      float: 'right',
	      fontFamily: 'Roboto',
	      cursor: 'pointer',
	      fontWeight: 400,
	      fontSize: '1em',
	      background: theme.palette.success,
	      border: 0,
	      padding: 8,
	      color: '#fff',
	      '&:hover': {
	        background: theme.palette.secondary.main
	      }
	    }, _subscribeButton[theme.breakpoints.down('xs')] = {
	      fontSize: '1em',
	      padding: 9
	    }, _subscribeButton),
	    successText: (_successText = {
	      textAlign: 'center',
	      color: theme.palette.successLighter,
	      fontSize: '0.8em'
	    }, _successText[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _successText),
	    errorText: (_errorText = {
	      fontFamily: 'Roboto',
	      textAlign: 'center',
	      color: theme.palette.error.light,
	      padding: 0,
	      fontSize: '0.8em'
	    }, _errorText[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _errorText),
	    checkIcon: {
	      color: theme.palette.successLighter,
	      fontSize: '2.5em'
	    },
	    errorIcon: {
	      color: theme.palette.error.main,
	      fontSize: '2.5em'
	    }
	  };
	};
	
	var renderInputField = function renderInputField(_ref) {
	  var input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      errorTextClassName = _ref.errorTextClassName,
	      customProps = _objectWithoutProperties(_ref, ['input', 'meta', 'errorTextClassName']);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    touched && error && _react2.default.createElement(
	      'div',
	      { className: errorTextClassName },
	      error
	    ),
	    _react2.default.createElement(_Input2.default, _extends({ error: touched && !!error }, input, customProps))
	  );
	};
	
	var SubscribeFormInArticle = function SubscribeFormInArticle(_ref2) {
	  var classes = _ref2.classes,
	      submitting = _ref2.submitting,
	      handleSubmit = _ref2.handleSubmit,
	      submitSucceeded = _ref2.submitSucceeded,
	      error = _ref2.error,
	      text = _ref2.text,
	      cta = _ref2.cta;
	
	  var actionProps = {};
	  var subscribeText = void 0,
	      subscribeCtaText = void 0,
	      oldBrowser = false;
	
	  if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) {
	    actionProps.onSubmit = handleSubmit;
	  } else {
	    oldBrowser = true;
	    actionProps.action = ("https://app.getresponse.com/add_subscriber.html");
	    actionProps.method = 'post';
	  }
	
	  if (!text) {
	    subscribeText = 'Like our content? Become a subscriber today to start receiving the latest, best trending health tips delivered straight to your inbox.';
	  } else {
	    subscribeText = text;
	  }
	
	  if (!cta) {
	    subscribeCtaText = 'Subscribe me!';
	  } else {
	    subscribeCtaText = cta;
	  }
	
	  return _react2.default.createElement(
	    'form',
	    _extends({
	      style: { opacity: submitting ? 0.4 : 1 },
	      className: classes.form
	    }, actionProps),
	    _react2.default.createElement('div', { className: classes.bg }),
	    _react2.default.createElement(
	      _Typography2.default,
	      {
	        variant: 'subheading',
	        className: classes.header,
	        align: 'center'
	      },
	      subscribeText
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_LinearProgress2.default, {
	        color: 'secondary',
	        style: {
	          position: 'relative',
	          width: '100%',
	          marginBottom: 5,
	          display: submitting ? 'block' : 'none'
	        }
	      }),
	      !submitSucceeded && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FormHelperText2.default,
	          { className: classes.helperText },
	          'ALL we need is your email address, it\'s dead simple!'
	        ),
	        !oldBrowser && _react2.default.createElement(_reduxForm.Field, {
	          errorTextClassName: classes.errorText,
	          inputProps: {
	            className: classes.inputs
	          },
	          className: classes.emailInput,
	          name: 'email',
	          type: 'email',
	          component: renderInputField,
	          placeholder: 'Your email',
	          disableUnderline: true,
	          required: true
	        }),
	        oldBrowser && _react2.default.createElement(_Input2.default, {
	          inputProps: { className: classes.inputs },
	          className: classes.emailInput,
	          name: 'email',
	          type: 'email',
	          placeholder: 'Your email',
	          disableUnderline: true,
	          required: true
	        }),
	        oldBrowser && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement('input', {
	            type: 'hidden',
	            name: 'thankyou_url',
	            value: window.location.href
	          }),
	          _react2.default.createElement('input', { type: 'hidden', name: 'forward_data', value: 'get' })
	        ),
	        _react2.default.createElement('input', { type: 'hidden', name: 'campaign_token', value: '6qdpg' }),
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(classes.inputs, classes.subscribeButton),
	          type: 'submit',
	          value: subscribeCtaText
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { clear: 'both' } },
	        submitSucceeded && !error && _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'caption', className: classes.successText },
	          _react2.default.createElement(_androidCheckmarkCircle2.default, { className: classes.checkIcon }),
	          ' Thank you, you\'re all set. Enjoy your read!'
	        ),
	        error && _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.errorText },
	          _react2.default.createElement(_errorOutline2.default, { className: classes.errorIcon }),
	          error
	        )
	      )
	    )
	  );
	};
	
	SubscribeFormInArticle.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  subscribe: _propTypes2.default.func.isRequired,
	  sendAlert: _propTypes2.default.func.isRequired,
	  text: _propTypes2.default.string,
	  cta: _propTypes2.default.string
	};
	
	exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles), (0, _reactRedux.connect)(null, { subscribe: _app.subscribe, sendAlert: _app.sendAlert }), (0, _reduxForm.reduxForm)({
	  form: 'SubscribeFormInArticle',
	  onSubmit: function onSubmit(values, _, _ref3) {
	    var subscribeUser = _ref3.subscribe,
	        reset = _ref3.reset,
	        sendAlert = _ref3.sendAlert;
	    return subscribeUser(_extends({ campaignToken: '6qdpg' }, values)).then(function () {
	      sendAlert({
	        message: "Awesome! You're now subscribed.",
	        type: 'success'
	      });
	      return reset();
	    }).catch(function (error) {
	      console.error(error);
	      var message = 'Either the email is already registered or an error occurred. Please try again later.';
	      sendAlert({ message: message, type: 'error' });
	      throw new _reduxForm.SubmissionError({ _error: message });
	    });
	  },
	  validate: function validate(_ref4) {
	    var email = _ref4.email;
	
	    var errors = {};
	    if (!email) {
	      errors.email = 'Please provide your email.';
	    }
	    if (!_regexp2.default.email.test(email)) {
	      errors.email = 'Please provide a valid email.';
	    }
	    return errors;
	  }
	}), _pure2.default)(SubscribeFormInArticle);
	module.exports = exports['default'];

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _kebabCase = __webpack_require__(712);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _Fade = __webpack_require__(128);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Divider = __webpack_require__(212);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Tags = __webpack_require__(287);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _ShareBar = __webpack_require__(368);
	
	var _ShareBar2 = _interopRequireDefault(_ShareBar);
	
	var _SubscribeFormInArticle = __webpack_require__(960);
	
	var _SubscribeFormInArticle2 = _interopRequireDefault(_SubscribeFormInArticle);
	
	var _Meta = __webpack_require__(48);
	
	var _FloatingSidebar = __webpack_require__(918);
	
	var _FloatingSidebar2 = _interopRequireDefault(_FloatingSidebar);
	
	var _Quote = __webpack_require__(916);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _NetlifyForm = __webpack_require__(957);
	
	var _NetlifyForm2 = _interopRequireDefault(_NetlifyForm);
	
	var _theme = __webpack_require__(213);
	
	var _formatDate = __webpack_require__(133);
	
	var _formatDate2 = _interopRequireDefault(_formatDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _extends2, _thumbnailWrapper, _title, _paginateButton;
	
	  return {
	    content: _extends({
	      position: 'relative'
	    }, (0, _theme.pageStyle)(theme), (_extends2 = {
	      margin: 0,
	      padding: 10,
	      width: 700
	    }, _extends2[theme.breakpoints.down('sm')] = {
	      width: '80%'
	    }, _extends2)),
	    thumbnailWrapper: (_thumbnailWrapper = {
	      width: '100%',
	      height: 430,
	      overflow: 'hidden'
	    }, _thumbnailWrapper[theme.breakpoints.down('xs')] = {
	      height: '100%'
	    }, _thumbnailWrapper),
	    thumbnail: {
	      width: '100%',
	      height: '100%',
	      objectFit: 'cover',
	      transition: 'transform 0.6s, opacity 1s ease-in !important',
	      '&:hover': {
	        transform: 'scale(1.3) rotate(-10deg)'
	      }
	    },
	    title: (_title = {
	      textTransform: 'none',
	      fontWeight: 500,
	      color: theme.palette.text.main,
	      padding: 10
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1.4em',
	      paddingTop: 0
	    }, _title),
	    originalAuthor: {
	      color: theme.palette.text.soft,
	      fontSize: '0.93em'
	    },
	    formatDate: {
	      color: theme.palette.text.soft,
	      paddingBottom: 10,
	      textAlign: 'center',
	      fontSize: '0.85em',
	      fontWeight: 300,
	      '&:hover': {
	        opacity: 1
	      }
	    },
	    // format date when there's last updated
	    withLastUpdated: {
	      paddingBottom: 0
	    },
	    paginateButton: (_paginateButton = {
	      textTransform: 'none',
	      background: theme.palette.primary.dark,
	      transition: 'color 0.5s, background 0.5s',
	      color: '#fff',
	      margin: '0 ' + theme.spacing.unit + 'px',
	      padding: 'auto 25px',
	      borderRadius: theme.spacing.unit * 5,
	      boxShadow: 'none',
	      '&:hover': {
	        color: theme.palette.primary.dark,
	        background: theme.palette.borders.ghost
	      }
	    }, _paginateButton[theme.breakpoints.down('xs')] = {
	      width: '100%',
	      fontSize: '0.8em'
	    }, _paginateButton),
	    tagsContainer: {
	      textAlign: 'center',
	      minHeight: 35
	    },
	    linkHover: {
	      color: theme.palette.link.main,
	      '&:hover': {
	        color: theme.palette.link.hovering
	      }
	    }
	  };
	};
	
	var PostTemplate = function PostTemplate(_ref) {
	  var _cx;
	
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      data = _ref.data,
	      pathContext = _ref.pathContext,
	      props = _objectWithoutProperties(_ref, ['classes', 'theme', 'data', 'pathContext']);
	
	  var previousPage = pathContext.previousPage,
	      nextPage = pathContext.nextPage,
	      articleBody = pathContext.articleBody;
	  var authorNode = data.authorNode,
	      post = data.post;
	
	  var baseUrl = 'https://healthfulinspired.com';
	
	  var datePublished = new Date(post.frontmatter.date).toISOString();
	  var dateModified = post.frontmatter.updateDate ? new Date(post.frontmatter.updateDate).toISOString() : post.frontmatter.updateDate;
	
	  var authorComponent = null,
	      postIsUpdated = false;
	
	  if (post.frontmatter.displayAuthor && post.frontmatter.originalAuthor) {
	    var _post$frontmatter = post.frontmatter,
	        originalAuthor = _post$frontmatter.originalAuthor,
	        editedBy = _post$frontmatter.editedBy;
	    // Link to author page if it exists
	
	    if (authorNode) {
	      authorComponent = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Typography2.default,
	          { align: 'center', className: classes.originalAuthor },
	          'Author:',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: authorNode.fields.slug, className: classes.linkHover },
	            originalAuthor
	          )
	        ),
	        editedBy && _react2.default.createElement(
	          _Typography2.default,
	          { align: 'center', className: classes.originalAuthor },
	          'Edited By:',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/authors/' + (0, _kebabCase2.default)(editedBy),
	              className: classes.linkHover
	            },
	            editedBy
	          )
	        )
	      );
	    } else {
	      authorComponent = _react2.default.createElement(
	        _Typography2.default,
	        { align: 'center', className: classes.originalAuthor },
	        'Author: ',
	        originalAuthor
	      );
	    }
	  }
	
	  {
	    var postDate = post.frontmatter.date;
	    var updateDate = post.frontmatter.updateDate; // eslint-disable-line
	    if (updateDate && updateDate > postDate) {
	      postIsUpdated = true;
	    }
	  }
	
	  var Image = function Image(props) {
	    return _react2.default.createElement('img', props);
	  }; // Fade passes in mandatory style prop
	
	  var shareLink = baseUrl + (0, _gatsbyLink.withPrefix)(post.fields.slug);
	
	  var hasQuote = post.frontmatter.quote ? !!post.frontmatter.quote.quote : false;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_FloatingSidebar2.default, {
	      shareLink: shareLink,
	      title: post.frontmatter.title,
	      thumbnail: post.frontmatter.thumbnail
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      {
	        className: classes.container,
	        id: 'articlePage',
	        spacing: 24,
	        justify: 'center',
	        alignItems: 'center',
	        style: { padding: '20px 0' },
	        container: true
	      },
	      _react2.default.createElement(_Meta.ArticleMeta, {
	        title: post.frontmatter.title,
	        shortDescription: post.frontmatter.shortDescription,
	        thumbnail: post.frontmatter.thumbnail,
	        genre: post.frontmatter.category,
	        tags: post.frontmatter.tags,
	        wordCount: post.wordCount.words,
	        datePublished: datePublished,
	        dateModified: dateModified,
	        articleBody: articleBody,
	        excerpt: post.excerpt,
	        path: post.fields.slug
	      }),
	      _react2.default.createElement(
	        _Grid2.default,
	        { className: classes.content, item: true },
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            variant: 'display1',
	            align: 'center',
	            classes: { display1: classes.title }
	          },
	          post.frontmatter.title
	        ),
	        authorComponent,
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            align: 'center',
	            className: (0, _classnames2.default)(classes.formatDate, (_cx = {}, _cx[classes.withLastUpdated] = postIsUpdated === true, _cx))
	          },
	          (0, _formatDate2.default)(post.frontmatter.date),
	          ' ',
	          '\u2022',
	          ' ',
	          post.timeToRead,
	          ' min read'
	        ),
	        postIsUpdated && _react2.default.createElement(
	          _Typography2.default,
	          {
	            align: 'center',
	            className: classes.formatDate,
	            style: { color: theme.palette.success }
	          },
	          'Last Updated: ',
	          (0, _formatDate2.default)(dateModified)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.thumbnailWrapper },
	          _react2.default.createElement(
	            _Fade2.default,
	            { timeout: 2000, 'in': true },
	            _react2.default.createElement(Image, {
	              className: classes.thumbnail,
	              src: post.frontmatter.thumbnail,
	              alt: post.frontmatter.title,
	              title: post.frontmatter.title
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 10 } },
	          _react2.default.createElement(_SubscribeFormInArticle2.default, {
	            text: post.frontmatter.subscriptionTextBeginning,
	            cta: post.frontmatter.subscriptionCTABeginning
	          })
	        ),
	        hasQuote && _react2.default.createElement(_Quote2.default, post.frontmatter.quote),
	        _react2.default.createElement(_ShareBar2.default, {
	          label: 'Share this post',
	          thumbnail: post.frontmatter.thumbnail,
	          title: post.frontmatter.title,
	          slug: post.fields.slug
	        }),
	        _react2.default.createElement('div', {
	          className: 'markdown',
	          dangerouslySetInnerHTML: { __html: post.html }
	        }),
	        post.frontmatter.displaySource && post.frontmatter.source && _react2.default.createElement(
	          _Typography2.default,
	          {
	            variant: 'subheading',
	            style: { padding: '15px 0', textTransform: 'none' }
	          },
	          '(This article was originally posted',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: post.frontmatter.source, target: '_blank' },
	            'here'
	          ),
	          ')'
	        ),
	        _react2.default.createElement(_ShareBar2.default, {
	          label: 'Did this information help you? Help support us and share it',
	          thumbnail: post.frontmatter.thumbnail,
	          title: post.frontmatter.title,
	          slug: post.fields.slug,
	          showBottomCounts: false
	        }),
	        _react2.default.createElement(_Divider2.default, { offset: 15 }),
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            variant: 'title',
	            style: { fontWeight: 600, padding: 12 },
	            align: 'center'
	          },
	          'Enjoyed the read?'
	        ),
	        _react2.default.createElement(_SubscribeFormInArticle2.default, {
	          text: post.frontmatter.subscriptionTextEnd,
	          cta: post.frontmatter.subscriptionCTAEnd
	        }),
	        _react2.default.createElement(_Divider2.default, { offset: 25 }),
	        _react2.default.createElement(EnhancedArticleNavigator, {
	          previousPage: previousPage,
	          nextPage: nextPage,
	          className: classes.paginateButton
	        }),
	        _react2.default.createElement(_Divider2.default, { offset: 25 }),
	        _react2.default.createElement(
	          'div',
	          { className: classes.tagsContainer },
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'body2' },
	            'tags: \xA0'
	          ),
	          _react2.default.createElement(_Tags2.default, { tags: post.frontmatter.tags })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        .markdown img {\n          width: 100%;\n          max-height: 380px;\n          object-fit: cover;\n          border: 1px solid ' + theme.palette.borders.cloudier + ';\n        }\n        .markdown {\n          color: ' + theme.palette.text.main + ';\n        }\n        table {\n          border: 1px solid ' + theme.palette.primary.main + ';\n        }\n        table th {\n          background: ' + theme.palette.primary.main + ';\n          color: #fff;\n          padding: 10px;\n        }\n        table td {\n          border: 1px solid ' + theme.palette.borders.cloud + ';\n        }\n        h1, h2, h3, h4, h5, h6 {\n          line-height: 1em;\n        }\n        h1 {\n          padding: 20px 0;\n        }\n        .instagram-media {\n          margin: auto !important;\n        }\n        @media (max-width: 600px) {\n          blockquote {\n            margin: 0;\n            padding-left: 8px;\n            border-left: 10px solid ' + theme.palette.borders.ghost + ';\n          }\n          .markdown h1, h2, h3 {\n            font-size: 1.4em;\n          }\n          .markdown img {\n            height: 100%;\n          }\n        }\n        '
	    )
	  );
	};
	
	PostTemplate.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.shape({
	    previousPage: _propTypes2.default.string,
	    nextPage: _propTypes2.default.string,
	    articleBody: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	function ArticleNavigator(_ref2) {
	  var previousPage = _ref2.previousPage,
	      nextPage = _ref2.nextPage,
	      className = _ref2.className;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { width: '100%', display: 'flex', justifyContent: 'center' } },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        component: previousPage && _gatsbyLink2.default,
	        to: previousPage,
	        variant: 'flat',
	        size: 'medium',
	        className: className,
	        style: { opacity: !previousPage && 0.35 },
	        disabled: !previousPage
	      },
	      'Previous article'
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        component: nextPage && _gatsbyLink2.default,
	        to: nextPage,
	        variant: 'flat',
	        size: 'medium',
	        className: className,
	        style: { opacity: !nextPage && 0.35 },
	        disabled: !nextPage
	      },
	      'Next article'
	    )
	  );
	}
	
	var EnhancedArticleNavigator = (0, _pure2.default)(ArticleNavigator);
	
	// eslint-disable-next-line
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(PostTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-js-a13c2955bed514e6add0.js